import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";

const DiscountCoupon = () => {
  const navigate = useNavigate();

  const coupons = [
    {
      id: 1,
      name: "Diwali Offer",
      code: "DIWALI10",
      discount: "5%",
      minSales: "10 orders",
      applicableTime: "Evening (4 PM – 8 PM)",
      validFrom: "25 August 2025",
      validTo: "30 August 2025",
      store: "#ST001 - Downtown Store",
      createdDate: "30 July 2025",
      active: true,
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Discount & Coupon Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Discount & Coupon Management
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={""}
              setDebouncedSearchTerm={() => { }}
              placeholder="Search coupons..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("add")}
            >
              Add Discount and Coupon
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Offer/Discount Name</TableCell>
                <TableCell>Coupon Code</TableCell>
                <TableCell>Discount</TableCell>
                <TableCell>Minimum Sales</TableCell>
                <TableCell>Applicable Time</TableCell>
                <TableCell>Valid From – To</TableCell>
                <TableCell>Store Detail</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {coupons.map((item, index) => (
                <TableRow hover key={item.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        borderColor: "#00B67A",
                        color: "#00B67A",
                        fontWeight: 600,
                        borderRadius: "6px",
                        px: 1.5,
                        py: 0.2,
                      }}
                    >
                      {item.code}
                    </Button>
                  </TableCell>
                  <TableCell>{item.discount}</TableCell>
                  <TableCell>{item.minSales}</TableCell>
                  <TableCell>{item.applicableTime}</TableCell>
                  <TableCell>
                    {item.validFrom} – {item.validTo}
                  </TableCell>
                  <TableCell>
                    <a href="/manage-stores/detail" className="click_action" onClick={() => navigate("/manage-stores/detail")}>
                      <b>{item.store}</b>
                    </a>
                  </TableCell>
                  <TableCell>{item.createdDate}</TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img onClick={() => navigate('view')} src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>
                      <IconButton>
                        <img onClick={() => navigate('add')} src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* <div className="table_footer">
          <p>Showing 1 to 1 of 1 entries</p>
          <div className="pagination_controls">
            <Button disabled>{"<<"}</Button>
            <Button disabled>{"<"}</Button>
            <Button variant="contained">1</Button>
            <Button disabled>{">"}</Button>
            <Button disabled>{">>"}</Button>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default DiscountCoupon;
